import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {OrganizationDataModel} from '../../../models/organization/organization-data.model';
import {Globals} from '../../../globals';
import {CfgTimeZoneModel} from '../../../models/configuration/cfg-timezone';

@Injectable({
  providedIn: 'root'
})
export class OfficeLocationsService {
  constructor(private http: HttpClient,
              private globals: Globals) { }

  getClients(): Observable<any[]> {
    let url: string;
    const method: string = 'client-office-location/tdo-clients';
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getTimeZones(): Observable<CfgTimeZoneModel[]> {
    let url: string;
    const method: string = `client-office-location-configuration/timezones`;
    url = environment.TDOurl + method;
    return this.http.get<CfgTimeZoneModel[]>(url);
  }

  getAllLocations(): Observable<ClientLocationDataModel[]> {
    let url: string;
    const method: string = `client-office-location-configuration/all-tdo-clients-locations/${this.globals.TDOCID}`;
    url = environment.TDOurl + method;
    return this.http.get<ClientLocationDataModel[]>(url);
  }

  getClientLocations(tdocid: string): Observable<ClientLocationDataModel[]> {
    let url: string;
    const method: string = 'ClientOfficeLocationConfiguration/TDOClientsLocations/' + tdocid;
    url = environment.TDOurl + method;
    return this.http.get<ClientLocationDataModel[]>(url);
  }

  saveLocation(model: ClientLocationDataModel): Observable<ClientLocationDataModel> {
    return this.http.post<ClientLocationDataModel>('api/client-office-location/save-location', model);
  }

  saveLocationOrganizationAndAddress(organization: OrganizationDataModel) {
    return this.http.post<OrganizationDataModel>('api/client-office-location/save-organization', organization);
  }

  deleteLocation(locId: number): Observable<void> {
    return this.http.get<void>(`api/client-office-location/delete-location/${locId}`);
  }

  saveOps(isNew: boolean, locToSave: any): Observable<any> {
    let url: string;
    if (isNew) {
      const method: string = 'ClientOfficeLocationConfiguration/TDONewLocationCreate';
      url = environment.TDOurl + method;
      return this.http.post<any>(url, locToSave);
    } else {
      const method: string = 'ClientOfficeLocationConfiguration/TDOLocationUpdate';
      url = environment.TDOurl + method + '/' + locToSave.LOCID;
      return this.http.put<any>(url, locToSave);
    }
  }
}
